import { PropsWithChildren, useEffect } from 'react';
import { App as AntdApp, ConfigProvider, theme as antdTheme, ThemeConfig } from 'antd';
import { useAppSelector } from '@/AppRedux/store/hooks';
import { RootState } from '@/AppRedux/reducers';

export default function ThemeConfigProvider({ children }: PropsWithChildren<{}>) {
  const themeState = useAppSelector((state:RootState) => state.theme);
  const data = themeState?.data || {};

  useEffect(() => {
    if (data?.token?.fontFamily) {
      document.body.style.fontFamily = data?.token.fontFamily as string;
    }
  }, [data?.token?.fontFamily]);

  useEffect(() => {
    // โหลดฟอนต์ runtime ถ้ามี fontFamilyUrl
    if (!data?.token?.fontFamilyUrl) return;
    const id = 'theme-font-link';
    let link = document.getElementById(id) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
    if (link.href !== data?.token?.fontFamilyUrl) link.href = data?.token?.fontFamilyUrl;
  }, [data?.token?.fontFamilyUrl]);


  const configGlobal: ThemeConfig = {
    algorithm:
      data.algorithm === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      ...data?.token,
      colorPrimary: data?.token?.colorPrimary,
      colorSuccess: data?.token?.colorSuccess,
      colorWarning: data?.token?.colorWarning,
      colorError: data?.token?.colorError,
      colorInfo: data?.token?.colorInfo,

      colorBgBase: data?.token?.colorBgBase,
      colorBgContainer: data?.token?.colorBgBase,
      colorTextBase: data?.token?.colorTextBase,

      colorBgLayout: data?.token?.colorBgBase,
      colorText: data?.token?.colorTextBase,

      borderRadius: data?.token?.borderRadius,
      fontFamily: data?.token?.fontFamily,
    },
    components: {
      ...data?.components,
      Layout: {
        ...(data.components?.Layout || {}),
        headerBg: (data.components?.Layout && data.components.Layout.headerBg) || data?.token?.colorBgBase || '#ffffff',
        headerColor: (data.components?.Layout && data.components.Layout.headerColor) || data?.token?.colorTextBase || '#1f1f1f',
      },
    } as any,
  };

  return (
    <ConfigProvider theme={configGlobal}>
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}
